import { getNumGpt3Tokens } from '@scale/llm-shared/tokenizers/countTokens';
import { ScaleLaunchBaseModelDisplayName, ScaleLaunchBaseModelInternalId } from '../consts';
import { IScaleLaunchBaseModel } from '../types';

export const Mpt7BInstruct: IScaleLaunchBaseModel = {
  id: ScaleLaunchBaseModelInternalId.Mpt7B,
  displayName: ScaleLaunchBaseModelDisplayName[ScaleLaunchBaseModelInternalId.Mpt7B],
  minTokensAllowed: 0,
  maxTokensAllowed: 4096,

  minTemperatureAllowed: 0,
  maxTemperatureAllowed: 1,
  externalModelId: '',
  costCentsPerMillionPromptTokens: 200,
  costCentsPerMillionCompletionTokens: 200,

  endpoint_short: 'end_ci69kggvvgqg03t54ffg',
  endpoint_streaming: 'n/a',

  getNumTokens: (prompt: string) => {
    return getNumGpt3Tokens(prompt);
  },
};
